import { InjectionToken } from '@angular/core';

export const IFRAME_URL_WHITELIST = new InjectionToken<string[]>('IFRAME_URL_WHITELIST', {
  providedIn: 'root',
  factory: () => [],
});
